/**
 * 3D Tour — same images as Home hero (`src/assets/hero banner/2/`), sorted like Hero carousel.
 */
import tourLiving from '../assets/hero banner/2/WhatsApp Image 2026-04-09 at 5.23.48 PM(1).png';
import tourBedroom from '../assets/hero banner/2/WhatsApp Image 2026-04-09 at 5.23.49 PM (1)(1).jpeg';
import tourKitchen from '../assets/hero banner/2/WhatsApp Image 2026-04-09 at 5.23.49 PM (2)(1).png';
import tourOffice from '../assets/hero banner/2/WhatsApp Image 2026-04-09 at 5.23.49 PM(1).png';

export const TOUR_ROOMS = {
  living: {
    id: 'living',
    name: 'Living Room',
    image: tourLiving,
    description: 'Modern luxury living space with wooden accents',
  },
  bedroom: {
    id: 'bedroom',
    name: 'Master Bedroom',
    image: tourBedroom,
    description: 'Cozy and elegant bedroom design',
  },
  kitchen: {
    id: 'kitchen',
    name: 'Modular Kitchen',
    image: tourKitchen,
    description: 'State-of-the-art kitchen with modern amenities',
  },
  office: {
    id: 'office',
    name: 'Home Office',
    image: tourOffice,
    description: 'Professional workspace with natural lighting',
  },
};

export const TOUR_ROOM_IDS = ['living', 'bedroom', 'kitchen', 'office'];
